import premadeColorsData from "../../data/mockData/premadeColorsData";
import mlPremadeColorsData from "../../data/mockData/mlPremadeColorsData";
import { types } from "./action";

const initialState = {
  linkLanding: premadeColorsData,
  musicLink: mlPremadeColorsData,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LINK_LANDING_PREMADE_COLORS:
      return {
        ...state,
        linkLanding: Array.isArray(action.payload) ? action.payload : state.linkLanding,
      };
    case types.SET_MUSIC_LINK_PREMADE_COLORS:
      return {
        ...state,
        musicLink: Array.isArray(action.payload) ? action.payload : state.musicLink,
      };
    default:
      return state;
  }
};
